import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight, AlertTriangle, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
interface CaseStudy {
  title: string;
  incident: string;
  damage: string;
  timeline: Array<{
    day: number;
    event: string;
  }>;
  outcome: string;
}
const caseStudies: CaseStudy[] = [{
  title: "Hausarztpraxis Berlin-Mitte",
  incident: "Ransomware-Angriff",
  damage: "35.500 €",
  timeline: [{
    day: 0,
    event: "Angriff entdeckt, Systeme isoliert"
  }, {
    day: 1,
    event: "IT-Forensik vor Ort, Analyse gestartet"
  }, {
    day: 3,
    event: "Datenwiederherstellung abgeschlossen"
  }, {
    day: 5,
    event: "Praxis wieder voll funktionsfähig"
  }],
  outcome: "Vollständige Kostenübernahme + Präventionsmaßnahmen finanziert. Keine Patientendaten verloren."
}, {
  title: "Zahnarztpraxis Berlin-Charlottenburg",
  incident: "DSGVO-Verstoß durch Datenleck",
  damage: "18.200 €",
  timeline: [{
    day: 0,
    event: "Datenleck bei Cloud-Anbieter entdeckt"
  }, {
    day: 1,
    event: "Anwalt & Datenschutzbeauftragter eingeschaltet"
  }, {
    day: 2,
    event: "Meldung an Aufsichtsbehörde"
  }, {
    day: 7,
    event: "Betroffene informiert, Bußgeld abgewendet"
  }],
  outcome: "Anwaltskosten übernommen, kein Bußgeld dank schneller Reaktion. Reputation geschützt."
}, {
  title: "MVZ Berlin-Spandau",
  incident: "DDoS-Angriff auf Terminbuchung",
  damage: "12.800 €",
  timeline: [{
    day: 0,
    event: "Website & Terminbuchung nicht erreichbar"
  }, {
    day: 0,
    event: "Notfall-Hotline aktiviert (< 2h)"
  }, {
    day: 1,
    event: "DDoS-Schutz implementiert"
  }, {
    day: 2,
    event: "Alle Systeme wieder online"
  }],
  outcome: "Betriebsausfall minimiert, Forensikkosten erstattet. Patienten konnten weiter telefonisch buchen."
}, {
  title: "Facharztpraxis Berlin-Pankow",
  incident: "Phishing-Angriff auf Mitarbeiter",
  damage: "9.400 €",
  timeline: [{
    day: 0,
    event: "Verdächtige E-Mail geöffnet"
  }, {
    day: 0,
    event: "IT-Sicherheitscheck durchgeführt"
  }, {
    day: 1,
    event: "Schadsoftware entfernt"
  }, {
    day: 2,
    event: "Mitarbeiter-Schulung durchgeführt"
  }],
  outcome: "Schnelle Reaktion verhinderte größeren Schaden. Schulungen für alle Mitarbeiter finanziert."
}];
const CaseStudiesCarousel = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "center"
  });
  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);
  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);
  const scrollTo = useCallback((index: number) => {
    if (emblaApi) emblaApi.scrollTo(index);
  }, [emblaApi]);
  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    emblaApi.on("select", onSelect);
    onSelect();
    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi]);
  return <section className="py-8 sm:py-12 lg:py-16 relative">
      
    </section>;
};
export default CaseStudiesCarousel;